import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteValidationMessage } from '../../../../_global/fragments/generated/CompleteValidationMessage';
import { ShareVisibility } from '../../fragments/generated/ShareVisibility';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type BulkToggleShareVisibilityMutationVariables = Types.Exact<{
  input: Types.BulkUpdateShareSettingsInput;
}>;


export type BulkToggleShareVisibilityMutation = { __typename?: 'Mutation', bulkUpdateShareSettings?: { __typename?: 'BulkUpdateShareSettingsPayload', results: Array<{ __typename?: 'BulkUpdateShareItemPayload', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null }> | null, result?: { __typename?: 'AdHocAssetsShare', id: string, enabled: boolean, expiration?: string | null, expiresIn?: number | null } | { __typename?: 'CollectionShare', id: string, enabled: boolean, expiration?: string | null, expiresIn?: number | null } | null }> } | null };


export const BulkToggleShareVisibility = /*#__PURE__*/ gql`
    mutation BulkToggleShareVisibility($input: BulkUpdateShareSettingsInput!) {
  bulkUpdateShareSettings(input: $input) {
    results {
      successful
      messages {
        ...CompleteValidationMessage
      }
      result {
        ...ShareVisibility
      }
    }
  }
}
    ${CompleteValidationMessage}
${ShareVisibility}` as unknown as DocumentNode<BulkToggleShareVisibilityMutation, BulkToggleShareVisibilityMutationVariables>;

          

          export const useBulkToggleShareVisibilityMutation = (options?:MutationHookOptions<BulkToggleShareVisibilityMutation, BulkToggleShareVisibilityMutationVariables>) => useMutation(BulkToggleShareVisibility, options);
          

          export type BulkToggleShareVisibilityMutationOptions = MutationHookOptions<BulkToggleShareVisibilityMutation, BulkToggleShareVisibilityMutationVariables>;

          

          export type BulkToggleShareVisibilityMutationResult = ReturnType<typeof useBulkToggleShareVisibilityMutation>[1];

          
